/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { tryDefine } from '@tylertech/forge-core';
import { KEY_TAG_NAME, KeyComponent } from './key';
export * from './key';
export function defineKeyComponent() {
    tryDefine(KEY_TAG_NAME, KeyComponent);
}
